<template>
  <div>
    <b-nav-item-dropdown class="dropdown-notification mr-75" menu-class="dropdown-menu-media dropdown-menu-right" left v-b-tooltip.hover.button.viewport="`${$t('alarm.alarms')}`">
      <template #button-content>
        <feather-icon :badge="notifications.length + recording_request.length" badge-classes="bg-danger"
          class="text-body" icon="BellIcon" size="21" />
      </template>

      <li class="dropdown-menu-header" v-if="recording_request.length > 0"
        :to="`/recording_request`" Read all notifications>
        <b-link :to="`/recording_request`">
          <div class="dropdown-header d-flex">
            <!-- TODO: Translate this -->
            <h4 class="notification-title mb-0 mr-auto">Recording Request</h4>
            <b-badge pill variant="light-primary">
              {{ `${recording_request.length} new recording request` }}</b-badge>
          </div>
        </b-link>
      </li>

      <!-- Header -->
      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex justify-content-between align-items-center">
          <h4 class="notification-title mb-0">
            {{ $t("alarm.alarms") }}
          </h4>
          <div>
            <b-button
              v-if="$can('create', 'AlarmCreation')"
              size="sm"
              @click="showModal()"
              style="margin-right: 5px;"
            >
              {{ $t("alarm.dispatchAlarm") }}
            </b-button>
            <b-badge pill variant="light-primary">
              {{ `${notifications.length} ${$t("alarm.new_alarms")}` }}
            </b-badge>
          </div>
        </div>
      </li>

      <!-- Notifications -->
      <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="scrollable-container media-list scroll-area"
        tagname="li">
        <!-- Account Notification -->
        <b-link v-for="notification in notifications" :key="notification.id" @click="openAlarmData(notification)">
          <b-media>
            <template #aside>
              <b-avatar size="32" :text="notification.alarm_acronym"
                :style="{ backgroundColor: getNotificationAvatarColor(notification) }">
              </b-avatar>
            </template>
            <p class="media-heading">
              <span class="font-weight-bolder">
                <template v-if="notification.is_assigned_to_current_user === true">
                  {{ getNotificationUnitDescription(notification) }} {{ $t('notifications.alarm.reassigned_suffix') }}
                  <small class="notification-text float-right">{{ notification.created_format_1 }}</small>
                </template>
                <template v-else-if="notification.is_reminder === true">
                  {{ getNotificationUnitDescription(notification) }} {{ $t('notifications.alarm.alarm_reminder_suffix') }}
                  <small class="notification-text float-right">{{ notification.created_format_1 }}</small>
                </template>
                <template v-else>
                  {{ getNotificationUnitDescription(notification) }}
                  <small class="notification-text float-right">{{ notification.created_format_1 }}</small>
                </template>
              </span>
            </p>
            <div v-if="notification.is_assigned_to_current_user === true" class="notification-text">
              {{ $t('notifications.alarm.assigned_alarm_subtitle') }}
            </div>
            <div v-else-if="notification.is_reminder === true && notification.reminder_message" class="notification-text">
              {{ notification.reminder_message }}
            </div>
            <small v-if="notification.is_assigned_to_current_user !== true" class="notification-text">
              {{ notification.alarm_status }}
            </small>
          </b-media>
        </b-link>

        <!-- System Notification Toggler -->
        <!-- <div class="media d-flex align-items-center">
                  <h6 class="font-weight-bolder mr-auto mb-0">{{ $t('downloads') }}</h6>
                  <b-form-checkbox :checked="true" switch />
              </div> -->

        <!-- System Notifications -->
        <!-- <b-link v-for="notification in systemNotifications" :key="notification.subtitle">
                  <b-media>
                      <template #aside>
                          <b-avatar size="32" :variant="notification.type">
                              <feather-icon :icon="notification.icon" />
                          </b-avatar>
                      </template>
                      <p class="media-heading">
                          <span class="font-weight-bolder">
                              {{ notification.title }}
                          </span>
                      </p>
                      <small class="notification-text">{{ notification.subtitle }}</small>
                  </b-media>
              </b-link> -->
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" block @click="removeAllNotification()">{{
        $t("notifications.read_allnotifications") }}</b-button>
    </li>
  </b-nav-item-dropdown>
  <dispatch-alarm-modal ref="dispatchAlarmModal" />
  </div>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { computed, onMounted, onUnmounted, getCurrentInstance, } from "@vue/composition-api";
import DispatchAlarmModal from "@/components/DispatchAlarmModal.vue";

export default {
  components: {
    DispatchAlarmModal,
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  setup() {
    store.dispatch("recording_request/getAllNotViewed");
    const vm = getCurrentInstance().proxy;
    const notifications = computed(() => store.getters["grid/getAlarms"]);
    const recording_request = computed(
      () => store.getters["recording_request/getItemsNotViewed"]
    );

    const openAlarmData = (data) => {
      // store.dispatch("grid/setIncomingAlarm", data);
      store.dispatch("grid/setAlarmId", data.id);
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED_RIGHT",
        0
      );
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED",
        1
      );

      if (data.is_assigned_to_current_user !== true) {
        store.dispatch("grid/removeNotificationAlarm", data);
      }
    };

    const removeAllNotification = () => {
      store.dispatch("grid/removeAllNotificationAlarm");
    };

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const connectSocket = () => {
      window.Echo.private(`recording-request`)
        .listen(".updated", (data) => {
          store.dispatch("recording_request/getAllNotViewed");
        })
        .listen(".created", (data) => {
          store.dispatch("recording_request/getAllNotViewed");
        });
    }

    const showModal = () => {
      vm.$root.$emit('bv::show::modal', 'dispatch_alarm_modal');
    };

    const getNotificationAvatarColor = (notification) => {
      return (notification.alarm_level && notification.alarm_level.color)
        || notification.alarm_type_color
        || "#6e7d88";
    };

    const getNotificationUnitDescription = (notification) => {
      return (notification.unit && notification.unit.description) || "";
    };

    onMounted(async () => {
      store.dispatch("grid/fetchAssignedAlarmNotifications");
      setTimeout(connectSocket, 2000);
    });

    onUnmounted(() => {
      window.Echo.leave(`recording-request`);
    });

    return {
      notifications,
      recording_request,
      perfectScrollbarSettings,
      openAlarmData,
      removeAllNotification,
      showModal,
      getNotificationAvatarColor,
      getNotificationUnitDescription,
    };
  },
};
</script>
